import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "stepper-nav" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1)
const _hoisted_3 = { class: "stepper-icon w-40px h-40px" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }, null, -1)
const _hoisted_5 = {
  class: "stepper-number",
  style: {"color":"#fff !important"}
}
const _hoisted_6 = { class: "stepper-label" }
const _hoisted_7 = { class: "stepper-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["stepper-item", {
        current: _ctx.currentStep == step.step,
        completed: _ctx.currentStep > step.step,
      }]),
        key: step.step,
        "data-kt-stepper-element": "nav"
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(step.step), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(step.title), 1)
        ])
      ], 2))
    }), 128))
  ]))
}